import { TracerouteHop } from '@bumble/app/types/cpeTypes';
import {
  Box,
  Button,
  List,
  ListItem,
  Typography
} from '@mui/material';
import { DateTime } from 'luxon';

interface TraceRouteDataProps {
  onClose: () => void;
  onTracerouteData: TracerouteHop[];
  selectedTitle: string;
  timestamp: string;
}

export const TraceRouteData = ({ onClose, onTracerouteData, selectedTitle, timestamp }: TraceRouteDataProps) => {
  const convertedDate = new Date(timestamp).valueOf();
  const date = DateTime.fromMillis(convertedDate);

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          padding: 3,
          maxWidth: 600,
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <Typography fontWeight="bold">
          {`${selectedTitle}: ${date.toFormat('M/dd/yyyy')}, ${date.toFormat('h:mm:ss a')}`}
        </Typography>
        <List dense sx={{ fontFamily: 'monospace' }}>
          {onTracerouteData.length ? onTracerouteData.map((hop, idx) => (
            <ListItem key={idx} divider alignItems="flex-start">
              <Box>
                <Typography variant="body1">
                  {`Hop ${hop.hop}: Host name ${hop.hostname || 'Unknown Host'}`}
                </Typography>
                <Typography variant="body2" sx={{ marginLeft: '5rem', color: 'text.secondary' }}>
                  {hop.ip || 'No IP'}
                </Typography>
              </Box>
            </ListItem>
          )) : <Typography variant="body1">The default gateway was unreachable.</Typography>}
        </List>
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}
        >
          <Button
            onClick={onClose}
            variant='outlined'
          >
            Close
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
